import config from '@config';

import createDataSource from './createDataSource';

const BASE_PATHNAME = 'game-appearance';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const create = ({ values, id }) => dataSource.post(BASE_PATHNAME, { json: { ...values, id } }).json();
  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();

  return {
    getById,
    create,
    update,
  };
};
